module.exports = __webpack_public_path__ + "static/media/pump.932ec1c6.jpeg";